import React from "react";
import { Box } from "@chakra-ui/react";
import { motion, useReducedMotion } from "framer-motion";

const MotionBox = motion.create(Box);
const COLORS = ["#e1171a", "#f59e0b", "#22c55e", "#3b82f6", "#a855f7", "#ec4899"];
const PIECES = Array.from({ length: 42 }, (_, index) => {
  const angle = (index / 42) * Math.PI * 2 + (index % 3) * 0.035;
  const distance = 58 + (index % 6) * 5;
  return {
  id: index,
  color: COLORS[index % COLORS.length],
  delay: (index % 7) * 0.025,
  duration: 1.8 + (index % 5) * 0.12,
  x: Math.cos(angle) * distance,
  y: Math.sin(angle) * distance,
  width: 7 + (index % 4) * 2,
  height: index % 3 === 0 ? 7 : 14,
  round: index % 4 === 0,
  };
});

export default function ConfettiCelebration() {
  const reduceMotion = useReducedMotion();
  if (reduceMotion) return null;

  return <Box aria-hidden="true" position="fixed" inset="0" overflow="hidden" pointerEvents="none" zIndex="0">
    {PIECES.map((piece) => <MotionBox
      key={piece.id}
      position="absolute"
      left="50%"
      top="50%"
      w={`${piece.width}px`}
      h={`${piece.height}px`}
      rounded={piece.round ? "full" : "2px"}
      bg={piece.color}
      initial={{ x: 0, y: 0, rotate: 0, scale: 0.2, opacity: 0 }}
      animate={{
        x: [0, `${piece.x * 0.42}vw`, `${piece.x}vw`],
        y: [0, `${piece.y * 0.42}vh`, `${piece.y}vh`],
        rotate: [0, 280, 720],
        scale: [0.2, 1, 0.8],
        opacity: [0, 1, 1, 0],
      }}
      transition={{ duration: piece.duration, delay: piece.delay, repeat: Infinity, repeatDelay: 0.55, ease: [0.18, 0.75, 0.25, 1] }}
    />)}
  </Box>;
}
